// Section 17: priority group 'Everyone else'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function everyoneElse(_config: Config) {
  return definePriorityGroup({
    id: 'everyone-else',
    label: 'Everyone else',
    section: 'S17',
    members: (ctx) => peopleSorted(ctx.state).map((p) => p.id),
  });
}
